import { Transaction, VersionedTransaction } from "@solana/web3.js";

export enum TransactionStatus {
    Rejected,
    Confirmed,
    Signed,
    Error
}

export interface InstructionAccountMeta {
    /// An account's public key.
    pubkey: string;
    /// True if an `Instruction` requires a `Transaction` signature matching `pubkey`.
    isSigner: boolean;
    /// True if the account data or metadata may be mutated during program execution.
    isWritable: boolean;
}

export type SendableTransaction = VersionedTransaction | Transaction;

export interface VersionedTransactionSignature {
    signature: string;
    publicKey: string;
}

// versioned transaction return from apis
export interface VersionedTransactionResponse {
    message: string;
    signatures: VersionedTransactionSignature[];
}

export interface SerializedTransactionsWithSetup {
    setupTransactions: string[];
    transactions: string[];
}

export type TransactionsWithSetup = SendableTransactionsWithSetup;

export interface SendableTransactionsWithSetup {
    setupTransactions: SendableTransaction[];
    transactions: SendableTransaction[];
}

export enum TransactionFeeLevel {
    Fast = "Fast", // Default
    Turbo = "Turbo", // 75th Percentile
    Ultra = "Ultra" // 95th Percentile
}

// Transaction generation type. Determines whether to use priority fees or JIT optimization (Jito).
export enum TransactionGenerationType {
    Priority, // Default transaction built with priority fees
    Jito, // JIT optimization transaction
    Both
}
export interface TransactionSettingsHeader {
    maxFee?: number;
    exactFee?: number;
    feeLevel?: TransactionFeeLevel;
    broadcastMode?: TransactionGenerationType;
}

export type TransactionsWithDataGenerateReturn<T extends object> = { transactions: SendableTransaction[] } & T;
